define(
    'viewmodels/secured/settings/settings',[
        "services/config",
        "viewmodels/ViewModelNotification",
        "providers/dataprovider",
        "plugins/router",
        "i19n!i19n/strings"
    ],
    function (config, ViewModelNotification, dataProvider, router, i19n) {
        var _storageGauge = null;
        var editorMessage = null;
        
        var vm = new ViewModelNotification(
        {
            i19n: i19n,

            usageData: {},
            pieData: [{ category: '', value: '' }],
            lineData: [{ name: '', data: [] }],
            categoryItems: [],
            
            usage_total: ko.observable('0'),
            usage_freespace: ko.observable('0'),
            usage_freespace_color: ko.observable('#478fca'),
            usage_deleted: ko.observable('0'),            

            purge_list: ko.observable(),
            purge_deletedText: ko.observable(),

            isAdmin: ko.observable(false),
            isInstanceAdmin: ko.observable(false),
            isUser: ko.observable(false),
            isCustomerTrial: ko.observable(true),
            isShowSubscription: ko.observable(false),
            version: ko.observable(''),
            isShareView: ko.observable(false),
            isPurgeView: ko.observable(false),
            message: ko.observable()
        });

        vm.activate = function () {
            vm.isAdmin(vm.session.role == 3 || vm.session.role == 4 ? true : false);
            vm.isInstanceAdmin(vm.session.role == 4 ? true : false);
            vm.isUser(vm.session.role == 2);            

            if (vm.isUser()) {
                router.navigate('#explorer');

                return false;
            }

            if (vm.isInstanceAdmin()) {
                vm.isShowSubscription(!(vm.session.isCustomerTrial == -1));
                vm.isCustomerTrial(vm.session.isCustomerTrial == -1 ? true : vm.session.isCustomerTrial);
            }

            dataProvider.settings
            .getFooter()
            .done(function (data) {
                vm.message(data);
            });

            return dataProvider.settings
                .getUsageSetting()
                .done(function (data) {
                    vm.usageData = data;                    

                    setStorageUsage();
                });
        };
        vm.attached = function () {
            //vm.version(String.format(i19n.to.todownloadthefileplanclientforwindows78learnmore, requirejs.s.contexts._.config.urlArgs.replace("version=", "")));
            //vm.version(requirejs.s.contexts._.config.urlArgs.replace("version=", ""));
            vm.version(window.fileplan.version.replace("version=", ""));

            //if ($('a#___subscriptionlink').length == 0) {
            //    var link = document.createElement('a');
                
            //    link.setAttribute('target', '_blank');
            //    link.setAttribute('id', '___subscriptionlink');

            //    document.body.appendChild(link);
            //}

            var self = this;

            self.notifications([]);

            var data = vm.usageData;
            
            //vm.usage_total(data.totalSpaceUsedMBText);
            //vm.usage_deleted(data.deletedMBText);
            //vm.usage_freespace(data.freeSpaceMBText);

            //vm.categoryItems = data.libraryGrowth.libraryGrowthCategoryItems;

            var c = _.chain(data.librarySpace)
                 .map(function (itm) { return { category: itm.libraryName, value: itm.spaceMB }; })
                 .value();

            //var l = _.chain(data.libraryGrowth.libraryGrowthItems)
            //    .map(function (itm) { return { name: itm.libraryName, data: itm.growthData }; })
            //    .value();

            vm.pieData = c;
            //vm.lineData = l;

            $("#chartPie").kendoChart({
                theme: 'Bootstrap',
                title: { text: i19n.to.spacebylibrary, position: "bottom" },
                legend: { position: "top" },
                seriesDefaults: {

                },
                series: [
                {
                    type: "pie",
                    startAngle: 90,
                    data: vm.pieData,
                    padding: 0
                }],

            });

            //$("#lineChart").kendoChart({
            //    title: { text: i19n.to.growthovertime, position: "bottom" },
            //    legend: { position: "top" },
            //    seriesDefaults: {
            //        type: "line"
            //    },
            //    series: vm.lineData,

            //    valueAxis: {
            //        line: {
            //            visible: false
            //        },
            //        axisCrossingValue: -10
            //    },

            //    categoryAxis: {
            //        categories: vm.categoryItems,
            //        majorGridlines: {
            //            visible: false
            //        }
            //    }
            //});

            // create Editor from textarea HTML element with default set of tools
            editorMessage = $("#editor-message-settings").kendoEditor({
                tools: [
                    "viewHtml",
                    "formatting",
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "justifyLeft",
                    "justifyCenter",
                    "justifyRight",
                    "justifyFull",
                    "insertUnorderedList",
                    "insertOrderedList",
                    "indent",
                    "outdent",
                    "createLink",
                    "unlink",
                    "insertImage",
                    "insertFile",
                    "subscript",
                    "superscript",
                    "createTable",
                    "addRowAbove",
                    "addRowBelow",
                    "addColumnLeft",
                    "addColumnRight",
                    "deleteRow",
                    "deleteColumn",                    
                    "cleanFormatting",
                    "fontName",
                    "fontSize",
                    "foreColor",
                    "backColor"
                ],
                resizable: {
                    content: true,
                    toolbar: true
                },
                change: function (e) {
                    vm.message(this.value());
                    
                    if (this._format) {
                        setDefaultFontEditor();
                        this._format = null;
                        vm.message(this.value());
                    }

                    if (vm.message() == "") {
                        this._format = true;
                    }
                }
            }).data("kendoEditor");

            if (vm.message() == "") {
                setDefaultFontEditor();
            }

            _storageGauge = $("#settings-gauge-storage").kendoProgressBar({
                type: "value",
                animation: false,
                change: function (e) {
                    this.progressWrapper.css({
                        "background-image": "none",
                        "border-image": "none"
                    });

                    var p = (e.value / this.options.max) * 100;
                    if (p > 89) {
                        this.progressWrapper.css({
                            "background-color": "#cc0033",
                            "border-color": "#cc0033"
                        });
                    } else {
                        this.progressWrapper.css({
                            "background-color": "#2b72ae",
                            "border-color": "#2b72ae"
                        });
                    }

                    if (e.value > 0)
                        this.progressStatus.text(e.value + " GB of " + this.options.max + " GB used");
                    else
                        this.progressStatus.text(this.options.max + " GB available");
                }
            }).data("kendoProgressBar");

            setStorageUsage();

            $("#purgeView").hide();            
            $("#shareView").hide();

            function setDefaultFontEditor() {
                var range = editorMessage.getRange();
                range.setStart(editorMessage.body, 0);
                range.setEnd(editorMessage.body, editorMessage.body.childNodes.length);
                editorMessage.selectRange(range);
                editorMessage.exec("fontName", { value: "Arial" });
                editorMessage.exec("fontSize", { value: "12pt" });
                range.collapse(true);
                editorMessage.selectRange(range);
            }
        };
        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };

        vm.usageClick = function () {
            var self = this;

            $("#usageView").show();
            $("#purgeView").hide();
            $("#shareView").hide();

            $("#usage").parent().addClass("active");
            $("#purge").parent().removeClass();
            $("#share").parent().removeClass();

            vm.isShareView(false);
            vm.isPurgeView(false);
        };
        vm.purgeClick = function () {
            var self = this;

            $("#purgeView").show();
            $("#usageView").hide();            
            $("#shareView").hide();

            $("#purge").parent().addClass("active");
            $("#usage").parent().removeClass();
            $("#share").parent().removeClass();

            vm.isShareView(false);
            vm.isPurgeView(true);

            dataProvider.settings
            .getPurgeSetting()
            .done(function (data) {
                self.purge_list(data.deletedDocumentRanges);
                self.purge_deletedText(data.deletedMBText);
                
                $(".purge-document-data").click(function () {
                    var no = $(this).attr("no");

                    dataProvider.settings
                    .purgeDocuments(no)
                    .done(function () {
                        self.notify(1, i19n.to.documentspurged);
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;
                        self.notify(e.error);
                    });
                });
                $(".csv-document-data").click(function () {
                    var instanceId = window.fileplan.instanceCode;
                    var lastxday = $(this).attr("no");
                    var location = getUrl(String.format("admin/adminsettings/purge/instancedeleted/{0}", instanceId));

                    if (lastxday != undefined) {
                        location = getUrl(String.format("admin/adminsettings/purge/instancedeleted/{0}/{1}", instanceId, lastxday));
                    }

                    window.location = location;

                    return false;
                });                
            });
        };
        vm.shareClick = function () {
            $("#shareView").show();
            $("#usageView").hide();
            $("#purgeView").hide();
            
            $("#share").parent().addClass("active");
            $("#usage").parent().removeClass();
            $("#purge").parent().removeClass();

            vm.isShareView(true);
            vm.isPurgeView(false);
        };
        vm.saveClick = function () {            
            dataProvider.settings
            .updateFooter(vm.message())
            .done(function () {
                vm.notify('success', "Share footer has been updated");
            })
            .fail(function (e) {
                //e.stopPropagation = true;
                console.error(e);
            });
        };
        vm.cancelClick = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };
        vm.manageSubscription = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var url = window.location.origin + window.location.pathname + "#plan/1";

                window.open(url, "_blank");

                complete();
            }
        });
        //vm.manageAccount = ko.asyncCommand({
        //    canExecute: function (isExecuting) {
        //        return !isExecuting;
        //    },
        //    execute: function (complete) {
        //        //also in people, explorer, account, settings
        //        dataProvider.subscription
        //        .getOrCreateSessionPortal({ redirectUrl: 'www.fileplanapp.com', instanceId: window.fileplan.instanceCode })
        //        .done(function (data) {
        //            $('a#___subscriptionlink')[0].setAttribute('href', data.accessUrl);
        //            $('a#___subscriptionlink')[0].click();
        //        })
        //        .fail(function (e) {
        //            e.stopPropagation = true;

        //            vm.notify(e.error);

        //            console.warn(e);
        //        })
        //        .always(complete);
        //    }
        //});
        vm.enterPayment = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var url = window.location.origin + window.location.pathname + "#plan";

                window.open(url, "_blank");

                complete();
            }
        });

        return vm;

        function setStorageUsage() {
            if (!_storageGauge)
                return;
            
            _storageGauge.options.max = 100;
            _storageGauge.value(1);
            _storageGauge.value(0);
            //_storageGauge.progressStatus.text("");
            
            //if (window.fileplan && window.fileplan.instanceCode && window.fileplan.instanceCode == "radfp01") {
            //    _test();
            //}

            dataProvider.subscription
            .getCustomerSubs()
            .done(function (subs) {
                
                _storageGauge.options.max = subs.subsMaxStorageLimit;
                _storageGauge.value((vm.usageData.totalSpaceUsedMB / 1024));

                var i = vm.usageData.totalSpaceUsedMB / 1024;
                var p = (i / _storageGauge.options.max) * 100;
                p = kendo.toString(p, 'n');
                vm.usage_total(p);


                vm.usage_freespace_color('#cc0033');
                var f = parseFloat(vm.usageData.freeSpaceMB);
                if (f > 1024) {
                    f = f / 1024;
                    if (f > 10) vm.usage_freespace_color('#478fca');
                    f = kendo.toString(f, 'n') + " GB";
                } else {
                    f = kendo.toString(f, 'n') + " MB";
                }
                vm.usage_freespace(f);


                var d = parseFloat(vm.usageData.deletedMB);
                if (d > 1024) {
                    d = d / 1024;
                    d = kendo.toString(d, 'n') + " GB";
                } else {
                    d = kendo.toString(d, 'n') + " MB";
                }
                vm.usage_deleted(d);
            })
            .fail(function (e) {
                e.stopPropagation = true;

                console.error(e);
            });

            function _test() {
                //vm.usageData.totalSpaceUsedMB = 90 * 1024;
                //vm.usageData.freeSpaceMB = 9 * 1024;
                //vm.usageData.deletedMB = 900;

                _storageGauge.options.max = 100;
                _storageGauge.value((vm.usageData.totalSpaceUsedMB / 1024));

                var i = vm.usageData.totalSpaceUsedMB / 1024;
                var p = (i / _storageGauge.options.max) * 100;
                p = kendo.toString(p, 'n');
                vm.usage_total(p);

                
                vm.usage_freespace_color('#cc0033');
                var f = Math.abs(vm.usageData.freeSpaceMB);
                if (f > 1024) {
                    f = f / 1024;
                    if (f > 10) vm.usage_freespace_color('#478fca');
                    f = kendo.toString(f, 'n') + " GB";
                } else {
                    f = kendo.toString(f, 'n') + " MB";
                }
                vm.usage_freespace(f);


                var d = vm.usageData.deletedMB;
                if (d > 1024) {
                    d = d / 1024;
                    d = kendo.toString(d, 'n') + " GB";
                } else {
                    d = kendo.toString(d, 'n') + " MB";
                }
                vm.usage_deleted(d);
            }
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }
    }
);
